import { render, staticRenderFns } from "./riskeylemonaydurum.vue?vue&type=template&id=8e6be96a"
import script from "./riskeylemonaydurum.vue?vue&type=script&lang=js"
export * from "./riskeylemonaydurum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports